import React, { Component } from "react";
import { toast } from "react-toastify";
import "./ventaDetalleModal.css";
import { descargarFactura } from "../../../service/api";

export default class VentaDetalleModal extends Component {
  constructor(props) {
    super(props);

    this.totalInputs = {};

    const initialState = this.buildStateFromProps(props);

    this.state = {
      ...initialState,
      originalData: JSON.parse(JSON.stringify(initialState)),
      hasChanges: false,
      showCancelarConfirm: false,
    };
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.onDocMouseDown);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.onDocMouseDown);
  }

  componentDidUpdate(prevProps) {
    const openedNow = !prevProps.show && this.props.show;
    const dataChanged = prevProps.data !== this.props.data;
    const catalogChanged =
      prevProps.array_catalogo_sat !== this.props.array_catalogo_sat;
    const nacionalidadesChanged =
      prevProps.array_nacionalidad !== this.props.array_nacionalidad;

    if (openedNow || dataChanged || catalogChanged || nacionalidadesChanged) {
      const nextState = this.buildStateFromProps(this.props);

      this.setState({
        ...nextState,
        originalData: JSON.parse(JSON.stringify(nextState)),
        hasChanges: false,
        showCancelarConfirm: false,
      });
    }
  }

  onDocMouseDown = (e) => {
    if (!this.state.nacOpen) return;

    const nacEl = this.nacWrapRef?.current;
    if (nacEl && !nacEl.contains(e.target)) {
      this.setState({ nacOpen: false });
    }
  };

  isSolicitudFacturada = () => {
    const tipo = this.props?.data?.tipo || "";
    const estatusTop =
      tipo === "Solicitud"
        ? this.state?.solicitud?.estatus || this.props?.data?.estatus || ""
        : "";

    return tipo === "Solicitud" && String(estatusTop).trim() === "Facturado";
  };

  markAsChanged = () => {
    if (!this.state.hasChanges) {
      this.setState({ hasChanges: true });
    }
  };

  isSameValue = (a, b) => {
    const aNum = this.parseNumber(a);
    const bNum = this.parseNumber(b);

    const aIsNumeric =
      a !== "" &&
      a !== null &&
      a !== undefined &&
      !Number.isNaN(Number(String(a).replace(",", ".")));
    const bIsNumeric =
      b !== "" &&
      b !== null &&
      b !== undefined &&
      !Number.isNaN(Number(String(b).replace(",", ".")));

    if (aIsNumeric && bIsNumeric) {
      return this.roundMoney(aNum) === this.roundMoney(bNum);
    }

    return String(a ?? "").trim() === String(b ?? "").trim();
  };

  normalizeViaForPayload = (via) => {
    return via || "";
  };

  getTipoCambioValue = (obj = {}) => {
    return obj?.tipo_cambio || obj?.tc || "—";
  };

  getProductosPayloadNormalizados = (productos = []) => {
    return productos.map((p) => {
      const montos = this.getProductoMontos(p);

      return {
        idticketproducto: Number(p.idticketproducto),
        total: p.seleccionado ? this.roundMoney(montos.total) : 0,
        activo: p.seleccionado ? 1 : 0,
      };
    });
  };

  parseNumber = (value) => {
    if (value == null || value === "") return 0;

    let clean = String(value).trim();

    clean = clean.replace(/\$/g, "");
    clean = clean.replace(/\s/g, "");

    if (clean.includes(",") && !clean.includes(".")) {
      clean = clean.replace(",", ".");
    } else if (clean.includes(",") && clean.includes(".")) {
      clean = clean.replace(/,/g, "");
    }

    const n = Number(clean);
    return Number.isNaN(n) ? 0 : n;
  };

  roundMoney = (value) => {
    const n = Number(value || 0);
    return Math.round((n + Number.EPSILON) * 100) / 100;
  };

  pesostable = (value) => {
    const amount = this.roundMoney(this.parseNumber(value));

    const number = new Intl.NumberFormat("es-MX", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount);

    return `$${number}`;
  };

  formatMoney = (value) => {
    const amount = this.roundMoney(this.parseNumber(value));

    const number = new Intl.NumberFormat("es-MX", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount);

    return `$ ${number}`;
  };


  formatMoneyInput = (value) => {
    if (value == null || value === "") return "";
    return String(value);
  };

  almostEqual = (a, b) => {
    return this.roundMoney(a) === this.roundMoney(b);
  };

  getProductoCantidad = (p) => {
    const qty = Math.floor(this.parseNumber(p?.cantidad));
    return qty > 0 ? qty : 1;
  };

  getProductoTotalMinimo = (p) => {
    return this.roundMoney(this.getProductoCantidad(p) * 0.01);
  };

  getProductoMontos = (p) => {
    if (!p?.seleccionado) {
      return {
        total: 0,
        subtotal: 0,
        iva: 0,
      };
    }

    const minimo = this.getProductoTotalMinimo(p);
    const capturado = this.parseNumber(p?.total_editable);
    const total = this.roundMoney(Math.max(capturado, minimo));
    const subtotal = this.roundMoney(total / 1.16);
    const iva = this.roundMoney(total - subtotal);

    return {
      total,
      subtotal,
      iva,
    };
  };

  normalizarTotalProducto = (p, rawValue) => {
    if (!p?.seleccionado) return "0.00";

    const minimo = this.getProductoTotalMinimo(p);
    const capturado = this.parseNumber(rawValue);
    const total = this.roundMoney(Math.max(capturado, minimo));

    return this.toMoneyInputValue(total);
  };

  buildStateFromProps = (props) => {
    const item = props.data || {};
    const tipo = item?.tipo || "";
    const solicitudApi = item?.solicitud || {};
    const pagoApi = item?.pago || {};
    const emisorApi = item?.emisor || {};
    const arrayNacionalidad = Array.isArray(props.array_nacionalidad)
      ? props.array_nacionalidad
      : [];

    const idNacionalidadApi = Number(solicitudApi?.idnacionalidad || 0);

    const nacionalidadEncontrada = arrayNacionalidad.find(
      (n) => Number(n?.idnacionalidad) === idNacionalidadApi
    );

    const nacionalidadTexto = String(
      nacionalidadEncontrada?.nacionalidad || solicitudApi?.nacionalidad || ""
    );

    const residenciaFiscalTexto = String(
      nacionalidadEncontrada?.codigo || solicitudApi?.residencia_fiscal || ""
    );

    return {
      emisor: {
        nombre: emisorApi?.nombre || "",
        rfc: emisorApi?.rfc || "",
        regimen_fiscal: emisorApi?.regimen_fiscal || "",
        lugar_expedicion: solicitudApi?.lugar_expedicion || "",
      },

      cfdi: {
        serie: solicitudApi?.serie || "",
        folio: solicitudApi?.folio || "",
        tipocambiofactura: item?.tipocambiofactura || "",
        tipocambio: item?.tipocambio || "",
        forma_pago: solicitudApi?.forma_pago || "",
        metodo_pago: solicitudApi?.metodo_pago || "",
        tipo_comprobante: solicitudApi?.tipo_comprobante || "I",
        uso_cfdi: solicitudApi?.uso_cfdi || "",
        moneda: item?.monedafactura || solicitudApi?.moneda || "MXN",
      },

      solicitud: {
        idsolicitudfactura: solicitudApi?.idsolicitudfactura || "",
        idticket: solicitudApi?.idticket || pagoApi?.idticket || "",
        folio: solicitudApi?.folio || "",
        fecha_factura:
          solicitudApi?.fecha_factura || pagoApi?.fecha_factura || "",
        fecha_transito: solicitudApi?.fecha_transito || "",
        nombre: solicitudApi?.nombre || "",
        apellido: solicitudApi?.apellido || "",
        rfc: solicitudApi?.rfc || "",
        regimen_fiscal: solicitudApi?.regimen_fiscal || "",
        domicilio_fiscal: solicitudApi?.domicilio_fiscal || "",
        residencia_fiscal: residenciaFiscalTexto,
        idnacionalidad: idNacionalidadApi || "",
        nacionalidad: nacionalidadTexto,
        tipo_transito: solicitudApi?.tipo_transito || "",
        tipo_id: "Pasaporte",
        pasaporte: solicitudApi?.pasaporte || "",
        via:
          solicitudApi?.via === "AEREA"
            ? "Aérea"
            : solicitudApi?.via === "MARITIMA"
              ? "Marítima"
              : solicitudApi?.via === "TERRESTRE"
                ? "Terrestre"
                : solicitudApi?.via || "",
        linea_transporte: solicitudApi?.linea_transporte || "",
        id_transporte: solicitudApi?.id_transporte || "",
        cantidad: solicitudApi?.cantidad || "",
        moneda: solicitudApi?.moneda || item?.monedafactura || "MXN",
        carpeta: solicitudApi?.carpeta || "",
        comentarios: solicitudApi?.comentarios || "",
        estatus: solicitudApi?.estatus || item?.estatus || "",
        locacion: solicitudApi?.locacion || pagoApi?.locacion || "",
        mensaje: item?.mensaje || "",
        mensajeajustes: item?.mensajeajustes || "",
        totalventas: item?.totalventas ?? "",
        totalventasMXN: item?.totalventasMXN || "",
        monedafactura: item?.monedafactura || "",
        totalfactura: item?.totalfactura || "",
        ivafactura: item?.ivafactura || "",
        tipocambiofactura: item?.tipocambiofactura || "",
      },

      productos: (item?.productos || []).map((p) => {
        const seleccionado =
          tipo === "Solicitud" ? Boolean(Number(p?.activo ?? 0)) : true;

        const qty =
          Math.floor(this.parseNumber(p?.cantidad)) > 0
            ? Math.floor(this.parseNumber(p?.cantidad))
            : 1;

        const minimo = this.roundMoney(qty * 0.01);
        const totalOriginal = this.parseNumber(p?.total);

        return {
          ...p,
          seleccionado,
          total_editable: seleccionado
            ? this.toMoneyInputValue(Math.max(totalOriginal, minimo))
            : "0.00",
        };
      }),

      nacOpen: false,
      nacQuery: nacionalidadTexto,
    };
  };

  getCatalogItems = (key) => {
    return this.props.array_catalogo_sat?.[key] || [];
  };

  getCatalogLabel = (key, clave) => {
    const items = this.getCatalogItems(key);
    const target = String(clave || "").trim();

    if (!target) return "";

    const found = items.find(
      (x) => String(x?.clave || "").trim() === target
    );

    if (!found) return "";

    switch (key) {
      case "forma_pago":
        return found.forma_pago || "";
      case "metodo_pago":
        return found.metodo_pago || "";
      case "regimen_fiscal":
        return found.regimen_fiscal || "";
      case "uso_cfdi":
        return found.uso_cfdi || "";
      case "tipo_comprobante":
        return found.tipo_comprobante || "";
      default:
        return "";
    }
  };

  getProductosSeleccionados = () => {
    return (this.state.productos || []).filter((p) => p.seleccionado);
  };

  getTotalProductosSeleccionados = () => {
    const total = this.getProductosSeleccionados().reduce((acc, p) => {
      const montos = this.getProductoMontos(p);
      return acc + montos.total;
    }, 0);

    return this.roundMoney(total);
  };

  getCantidadSolicitud = () => {
    return this.parseNumber(this.state.solicitud?.cantidad);
  };

  isProductosTotalValido = () => {
    const suma = this.roundMoney(this.getTotalProductosSeleccionados());
    const cantidadCfdi = this.roundMoney(
      this.parseNumber(this.state.solicitud?.cantidad)
    );

    if (cantidadCfdi <= 0) return false;

    return suma === cantidadCfdi;
  };

  getPrimaryActionConfig = () => {
    const hasMensaje = !!String(this.state?.solicitud?.mensaje || "").trim();
    const { hasChanges } = this.state;
    const isFacturada = this.isSolicitudFacturada();

    if (isFacturada) {
      return {
        label: "Cancelar factura",
        disabled: false,
        onClick: this.onCancelarFactura,
      };
    }

    if (hasChanges) {
      return {
        label: "Guardar",
        disabled: false,
        onClick: this.onGuardar,
      };
    }

    return {
      label: "Facturar",
      disabled: hasMensaje,
      onClick: this.onFacturar,
    };
  };

  closeOnBackdrop = (e) => {
    if (e.target.classList.contains("vd-backdrop")) {
      this.props.onClose && this.props.onClose();
    }
  };

  onSolicitudChange = (field, value) => {
    if (this.isSolicitudFacturada()) return;

    this.setState((prev) => ({
      solicitud: {
        ...prev.solicitud,
        [field]: value,
      },
      cfdi:
        field === "moneda"
          ? {
            ...prev.cfdi,
            moneda: value,
          }
          : prev.cfdi,
      hasChanges: true,
    }));
  };

  onCfdiChange = (field, value) => {
    if (this.isSolicitudFacturada()) return;

    this.setState((prev) => ({
      cfdi: {
        ...prev.cfdi,
        [field]: value,
      },
      solicitud:
        field === "moneda"
          ? {
            ...prev.solicitud,
            moneda: value,
          }
          : prev.solicitud,
      hasChanges: true,
    }));
  };

  onEmisorChange = (field, value) => {
    if (this.isSolicitudFacturada()) return;

    this.setState((prev) => ({
      emisor: {
        ...prev.emisor,
        [field]: value,
      },
      hasChanges: true,
    }));
  };

  onNacionalidadSelect = (idValue) => {
    if (this.isSolicitudFacturada()) return;

    const idnacionalidad = Number(idValue || 0);

    const nacionalidades = Array.isArray(this.props.array_nacionalidad)
      ? this.props.array_nacionalidad
      : [];

    const found = nacionalidades.find(
      (n) => Number(n?.idnacionalidad) === idnacionalidad
    );

    this.setState((prev) => ({
      solicitud: {
        ...prev.solicitud,
        idnacionalidad: idnacionalidad || "",
        nacionalidad: String(found?.nacionalidad || ""),
        residencia_fiscal: String(found?.codigo || ""),
      },
      hasChanges: true,
    }));
  };

  onFacturar = async () => {
    try {
      const idsolicitudfactura = Number(
        this.state?.solicitud?.idsolicitudfactura || 0
      );
      //   const idticket = Number(this.state?.solicitud?.idticket || 0);

      if (!idsolicitudfactura) {
        toast.info("No se encontró el id de la solicitud.");
        if (this.props.onFacturar) {
          await this.props.onFacturar();
        }
        return;
      }

      const resp = await descargarFactura({ idsolicitudfactura });

      if (resp?.code === 0) {
        // const xmlContent = String(resp.data || "").trim();

        /*
        if (xmlContent) {
          const blob = new Blob([xmlContent], {
            type: "application/xml;charset=utf-8",
          });

          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = `factura_${idticket}.xml`;

          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);

          setTimeout(() => {
            window.URL.revokeObjectURL(url);
          }, 1000);
        }
        */

        toast.success(resp.message || "Factura generada exitosamente.");
      } else {
        toast.info(resp?.message || "No fue posible generar la factura.");
      }

      if (this.props.onFacturar) {
        await this.props.onFacturar();
      }
    } catch (e) {
      toast.info("No fue posible descargar la factura.");

      if (this.props.onFacturar) {
        await this.props.onFacturar();
      }
    }
  };

  onCancelarFactura = () => {
    const folio = String(
      this.state?.solicitud?.folio || this.state?.cfdi?.folio || ""
    ).trim();

    if (!folio) {
      toast.info("No se encontró el folio de la factura.");
      return;
    }

    this.setState({ showCancelarConfirm: true });
  };

  closeCancelarConfirm = () => {
    this.setState({ showCancelarConfirm: false });
  };

  confirmarCancelarFactura = () => {
    const idsolicitudfactura = String(
      this.state?.solicitud?.idsolicitudfactura ||
      this.state?.cfdi?.idsolicitudfactura ||
      ""
    ).trim();

    this.setState({ showCancelarConfirm: false }, () => {
      if (idsolicitudfactura && this.props.onCancelarFactura) {
        this.props.onCancelarFactura(idsolicitudfactura);
      }
    });
  };

  toMoneyInputValue = (value) => {
    return this.roundMoney(this.parseNumber(value)).toFixed(2);
  };

  onToggleProducto = (idticketproducto) => {
    if (this.isSolicitudFacturada()) return;

    this.setState(
      (prev) => ({
        productos: prev.productos.map((p) => {
          if (p.idticketproducto !== idticketproducto) return p;

          const nuevoSeleccionado = !p.seleccionado;

          return {
            ...p,
            seleccionado: nuevoSeleccionado,
            total_editable: nuevoSeleccionado
              ? this.normalizarTotalProducto(
                { ...p, seleccionado: true },
                p.total_editable
              )
              : "0.00",
          };
        }),
        hasChanges: true,
      }),
      () => {
        const producto = this.state.productos.find(
          (p) => p.idticketproducto === idticketproducto
        );

        if (producto?.seleccionado) {
          const input = this.totalInputs[idticketproducto];
          if (input) {
            input.focus();
          }
        }
      }
    );
  };

  onProductoTotalChange = (idticketproducto, value) => {
    if (this.isSolicitudFacturada()) return;

    this.setState((prev) => {
      const productos = prev.productos.map((p) =>
        p.idticketproducto === idticketproducto
          ? { ...p, total_editable: value }
          : p
      );

      const nextState = {
        ...prev,
        productos,
      };

      return {
        productos,
        hasChanges: this.computeHasChanges(nextState),
      };
    });
  };

  onProductoTotalBlur = (idticketproducto) => {
    if (this.isSolicitudFacturada()) return;

    this.setState((prev) => {
      let changed = false;

      const productos = prev.productos.map((p) => {
        if (p.idticketproducto !== idticketproducto) return p;

        const normalizado = this.normalizarTotalProducto(p, p.total_editable);

        if (String(normalizado) !== String(p.total_editable || "")) {
          changed = true;
          return {
            ...p,
            total_editable: normalizado,
          };
        }

        return p;
      });

      if (!changed) return null;

      return {
        productos,
        hasChanges: true,
      };
    });
  };

  computeHasChanges = (nextState) => {
    const original = nextState.originalData || this.state.originalData || {};

    const payloadActual = {
      solicitud: nextState.solicitud,
      cfdi: nextState.cfdi,
      emisor: nextState.emisor,
      productos: this.getProductosPayloadNormalizados(nextState.productos || []),
    };

    const payloadOriginal = {
      solicitud: original.solicitud || {},
      cfdi: original.cfdi || {},
      emisor: original.emisor || {},
      productos: this.getProductosPayloadNormalizados(original.productos || []),
    };

    return JSON.stringify(payloadActual) !== JSON.stringify(payloadOriginal);
  };

  hasSpecialChars = (value) => {
    return /[<>[\]{}|^~`]/.test(String(value || "").trim());
  };

  isOnlyText = (value) => {
    return /^[A-Za-zÁÉÍÓÚáéíóúÑñÜü\s'.-]+$/.test(
      String(value || "").trim()
    );
  };

  isAlphaNumericText = (value) => {
    return /^[A-Za-z0-9ÁÉÍÓÚáéíóúÑñÜü\s.,#/-]+$/.test(
      String(value || "").trim()
    );
  };

  preventNumberScrollChange = (e) => {
    e.target.blur();
  };

  validateSolicitudBeforeSave = () => {
    const { solicitud, cfdi, emisor } = this.state;

    if (this.getProductosSeleccionados().length === 0) {
      toast.info("Debes seleccionar al menos un producto.");
      return false;
    }

    const productoInvalido = this.getProductosSeleccionados().find((p) => {
      const minimo = this.getProductoTotalMinimo(p);
      const total = this.getProductoMontos(p).total;
      return total < minimo;
    });

    if (productoInvalido) {
      toast.info(
        `El producto "${productoInvalido.producto || "Sin nombre"
        }" debe tener un total mínimo de ${this.formatMoney(
          this.getProductoTotalMinimo(productoInvalido)
        )} según su cantidad (${this.getProductoCantidad(productoInvalido)}).`,
        { autoClose: 7000 }
      );
      return false;
    }

    const sumaProductos = this.getTotalProductosSeleccionados();
    const cantidadCfdi = this.parseNumber(solicitud.cantidad);

    if (!this.almostEqual(sumaProductos, cantidadCfdi)) {
      toast.info(
        `La suma de los productos (${this.formatMoney(
          sumaProductos
        )}) debe coincidir con la Cantidad del CFDI (${this.formatMoney(
          cantidadCfdi
        )}).`,
        { autoClose: 7000 }
      );
      return false;
    }

    if (!String(solicitud.nombre || "").trim()) {
      toast.info("El nombre es obligatorio.");
      return false;
    }

    if (!String(solicitud.apellido || "").trim()) {
      toast.info("El apellido es obligatorio.");
      return false;
    }

    if (!this.isOnlyText(solicitud.apellido)) {
      toast.info("El apellido solo debe contener texto.");
      return false;
    }

    if (!String(solicitud.rfc || "").trim()) {
      toast.info("El RFC es obligatorio.");
      return false;
    }

    if (this.hasSpecialChars(solicitud.rfc)) {
      toast.info("El RFC contiene caracteres no permitidos.");
      return false;
    }

    if (!String(solicitud.regimen_fiscal || "").trim()) {
      toast.info("Debes seleccionar el régimen fiscal.");
      return false;
    }

    if (!String(solicitud.domicilio_fiscal || "").trim()) {
      toast.info("El código postal es obligatorio.");
      return false;
    }

    if (!String(solicitud.residencia_fiscal || "").trim()) {
      toast.info("La residencia fiscal es obligatoria.");
      return false;
    }

    if (this.hasSpecialChars(solicitud.residencia_fiscal)) {
      toast.info("La residencia fiscal contiene caracteres no permitidos.");
      return false;
    }

    if (!String(solicitud.fecha_factura || "").trim()) {
      toast.info("La fecha de factura es obligatoria.");
      return false;
    }

    if (!String(solicitud.fecha_transito || "").trim()) {
      toast.info("La fecha de tránsito es obligatoria.");
      return false;
    }

    if (!String(solicitud.tipo_transito || "").trim()) {
      toast.info("Debes seleccionar el tipo de tránsito.");
      return false;
    }

    if (!String(solicitud.pasaporte || "").trim()) {
      toast.info("El pasaporte es obligatorio.");
      return false;
    }

    if (!Number(solicitud.idnacionalidad || 0)) {
      toast.info("Debes seleccionar una nacionalidad válida.");
      return false;
    }

    if (!String(solicitud.via || "").trim()) {
      toast.info("La vía es obligatoria.");
      return false;
    }

    if (this.hasSpecialChars(solicitud.via)) {
      toast.info("La vía contiene caracteres no permitidos.");
      return false;
    }

    if (!String(solicitud.linea_transporte || "").trim()) {
      toast.info("La línea de transporte es obligatoria.");
      return false;
    }

    if (!this.isAlphaNumericText(solicitud.linea_transporte)) {
      toast.info("La línea de transporte contiene caracteres no permitidos.");
      return false;
    }

    if (!String(solicitud.id_transporte || "").trim()) {
      toast.info("El ID de transporte es obligatorio.");
      return false;
    }

    if (!this.isAlphaNumericText(solicitud.id_transporte)) {
      toast.info("El ID de transporte contiene caracteres no permitidos.");
      return false;
    }

    if (!String(solicitud.cantidad || "").trim()) {
      toast.info("La cantidad es obligatoria.");
      return false;
    }

    if (this.parseNumber(solicitud.cantidad) <= 0) {
      toast.info("La cantidad debe ser mayor a 0.");
      return false;
    }

    if (!String(cfdi.moneda || "").trim()) {
      toast.info("Debes seleccionar la moneda.");
      return false;
    }

    if (!String(cfdi.forma_pago || "").trim()) {
      toast.info("Debes seleccionar la forma de pago.");
      return false;
    }

    if (!String(cfdi.metodo_pago || "").trim()) {
      toast.info("Debes seleccionar el método de pago.");
      return false;
    }

    if (!String(cfdi.tipo_comprobante || "").trim()) {
      toast.info("Debes seleccionar el tipo de comprobante.");
      return false;
    }

    if (!String(cfdi.uso_cfdi || "").trim()) {
      toast.info("Debes seleccionar el uso CFDI.");
      return false;
    }

    if (!String(emisor.lugar_expedicion || "").trim()) {
      toast.info("El lugar de expedición es obligatorio.");
      return false;
    }

    if (this.hasSpecialChars(emisor.lugar_expedicion)) {
      toast.info("El lugar de expedición contiene caracteres no permitidos.");
      return false;
    }

    return true;
  };

  getPayloadSolicitud = () => {
    const { data } = this.props;
    const { solicitud, productos, cfdi, emisor, originalData } = this.state;

    const payload = {
      idsolicitudfactura: Number(solicitud?.idsolicitudfactura || 0),
    };

    const originalSolicitud = originalData?.solicitud || {};
    const originalCfdi = originalData?.cfdi || {};
    const originalEmisor = originalData?.emisor || {};
    const originalProductos = originalData?.productos || [];

    const pushIfChanged = (key, currentValue, originalValue) => {
      if (!this.isSameValue(currentValue, originalValue)) {
        payload[key] = currentValue;
      }
    };

    pushIfChanged(
      "ticket",
      String(solicitud?.idticket || ""),
      String(originalSolicitud?.idticket || "")
    );
    pushIfChanged(
      "fecha_factura",
      solicitud?.fecha_factura || "",
      originalSolicitud?.fecha_factura || ""
    );
    pushIfChanged(
      "fecha_transito",
      solicitud?.fecha_transito || "",
      originalSolicitud?.fecha_transito || ""
    );
    pushIfChanged(
      "nombre",
      solicitud?.nombre || "",
      originalSolicitud?.nombre || ""
    );
    pushIfChanged(
      "apellido",
      solicitud?.apellido || "",
      originalSolicitud?.apellido || ""
    );
    pushIfChanged(
      "idnacionalidad",
      Number(solicitud?.idnacionalidad || 0),
      Number(originalSolicitud?.idnacionalidad || 0)
    );
    pushIfChanged(
      "nacionalidad",
      solicitud?.nacionalidad || "",
      originalSolicitud?.nacionalidad || ""
    );
    pushIfChanged(
      "pasaporte",
      solicitud?.pasaporte || "",
      originalSolicitud?.pasaporte || ""
    );
    pushIfChanged(
      "via",
      this.normalizeViaForPayload(solicitud?.via),
      this.normalizeViaForPayload(originalSolicitud?.via)
    );
    pushIfChanged(
      "idlocacion",
      Number(data?.solicitud?.idlocacion || data?.pago?.idlocacion || 0),
      Number(data?.solicitud?.idlocacion || data?.pago?.idlocacion || 0)
    );
    pushIfChanged(
      "cantidad",
      this.parseNumber(solicitud?.cantidad),
      this.parseNumber(originalSolicitud?.cantidad)
    );
    pushIfChanged(
      "moneda",
      cfdi?.moneda || "MXN",
      originalCfdi?.moneda || originalSolicitud?.moneda || "MXN"
    );
    pushIfChanged(
      "carpeta",
      solicitud?.carpeta || "",
      originalSolicitud?.carpeta || ""
    );
    pushIfChanged(
      "comentarios",
      solicitud?.comentarios || "",
      originalSolicitud?.comentarios || ""
    );
    pushIfChanged(
      "rfc",
      solicitud?.rfc || "",
      originalSolicitud?.rfc || ""
    );
    pushIfChanged(
      "regimen_fiscal",
      solicitud?.regimen_fiscal || "",
      originalSolicitud?.regimen_fiscal || ""
    );
    pushIfChanged(
      "domicilio_fiscal",
      solicitud?.domicilio_fiscal || "",
      originalSolicitud?.domicilio_fiscal || ""
    );
    pushIfChanged(
      "residencia_fiscal",
      solicitud?.residencia_fiscal || "",
      originalSolicitud?.residencia_fiscal || ""
    );
    pushIfChanged(
      "tipo_transito",
      solicitud?.tipo_transito || "",
      originalSolicitud?.tipo_transito || ""
    );
    pushIfChanged(
      "linea_transporte",
      solicitud?.linea_transporte || "",
      originalSolicitud?.linea_transporte || ""
    );
    pushIfChanged(
      "id_transporte",
      solicitud?.id_transporte || "",
      originalSolicitud?.id_transporte || ""
    );
    pushIfChanged("serie", cfdi?.serie || "", originalCfdi?.serie || "");
    pushIfChanged("folio", cfdi?.folio || "", originalCfdi?.folio || "");
    pushIfChanged(
      "forma_pago",
      cfdi?.forma_pago || "",
      originalCfdi?.forma_pago || ""
    );
    pushIfChanged(
      "metodo_pago",
      cfdi?.metodo_pago || "",
      originalCfdi?.metodo_pago || ""
    );
    pushIfChanged(
      "tipo_comprobante",
      cfdi?.tipo_comprobante || "",
      originalCfdi?.tipo_comprobante || ""
    );
    pushIfChanged(
      "uso_cfdi",
      cfdi?.uso_cfdi || "",
      originalCfdi?.uso_cfdi || ""
    );
    pushIfChanged(
      "lugar_expedicion",
      emisor?.lugar_expedicion || "",
      originalEmisor?.lugar_expedicion || ""
    );

    const productosActuales = this.getProductosPayloadNormalizados(productos);
    const productosOriginales =
      this.getProductosPayloadNormalizados(originalProductos);

    const productosChanged =
      JSON.stringify(productosActuales) !==
      JSON.stringify(productosOriginales);

    if (productosChanged) {
      payload.productos = productosActuales;
    }

    return payload;
  };

  onGuardar = () => {
    if (this.isSolicitudFacturada()) return;
    if (!this.validateSolicitudBeforeSave()) return;

    const payload = this.getPayloadSolicitud();

    if (
      Object.keys(payload).length === 1 &&
      Number(payload.idsolicitudfactura || 0) > 0
    ) {
      toast.info("No hay cambios que guardar.");
      return;
    }

    if (this.props.onSave) {
      this.props.onSave(payload);
    }
  };

  renderEmptyField = (extraClass = "") => (
    <div className={`vd-field vd-fieldEmpty ${extraClass}`} aria-hidden="true" />
  );
  renderReadField = (label, value, extraClass = "", valueClass = "") => (
    <div className={`vd-field ${extraClass}`}>
      <label>{label}</label>
      <div className={`vd-value ${valueClass}`}>{value || "—"}</div>
    </div>
  );

  renderEditField = (
    label,
    field,
    value,
    type = "text",
    extraClass = "",
    placeholder = ""
  ) => {
    const isDisabled = this.isSolicitudFacturada();

    return (
      <div className={`vd-field ${extraClass}`}>
        <label>{label}</label>
        <input
          type={type}
          value={value || ""}
          placeholder={placeholder}
          disabled={isDisabled}
          readOnly={isDisabled}
          onChange={(e) => this.onSolicitudChange(field, e.target.value)}
        />
      </div>
    );
  };

  renderCfdiField = (
    label,
    field,
    value,
    type = "text",
    extraClass = "",
    placeholder = ""
  ) => {
    const isDisabled = this.isSolicitudFacturada();

    return (
      <div className={`vd-field ${extraClass}`}>
        <label>{label}</label>
        <input
          type={type}
          value={value || ""}
          placeholder={placeholder}
          disabled={isDisabled}
          readOnly={isDisabled}
          onChange={(e) => this.onCfdiChange(field, e.target.value)}
        />
      </div>
    );
  };

  renderTextAreaField = (
    label,
    field,
    value,
    extraClass = "",
    placeholder = ""
  ) => {
    const isDisabled = this.isSolicitudFacturada();

    return (
      <div className={`vd-field ${extraClass}`}>
        <label>{label}</label>
        <textarea
          className="vd-textarea"
          value={value || ""}
          placeholder={placeholder}
          disabled={isDisabled}
          readOnly={isDisabled}
          onChange={(e) => this.onSolicitudChange(field, e.target.value)}
        />
      </div>
    );
  };

  renderSelectField = ({
    label,
    value,
    onChange,
    options = [],
    extraClass = "",
    placeholder = "Selecciona",
  }) => {
    const isDisabled = this.isSolicitudFacturada();

    return (
      <div className={`vd-field ${extraClass}`}>
        <label>{label}</label>
        <select
          value={value || ""}
          disabled={isDisabled}
          onChange={(e) => onChange(e.target.value)}
        >
          <option value="">{placeholder}</option>
          {options.map((opt, idx) => (
            <option
              key={`${opt?.value || opt?.clave}-${idx}`}
              value={opt?.value || opt?.clave || ""}
            >
              {opt?.label || opt?.text || ""}
            </option>
          ))}
        </select>
      </div>
    );
  };

  renderResumen = () => {
    const { data } = this.props;
    const { solicitud } = this.state;
    const tipo = data?.tipo || "";
    const solicitudApi = data?.solicitud || {};
    const pago = data?.pago || {};
    const isFacturada = this.isSolicitudFacturada();

    const ticket = solicitudApi.idticket || pago.idticket || "—";
    const estatusTop =
      tipo === "Solicitud"
        ? solicitud.estatus || data?.estatus || "—"
        : pago.estatus || data?.estatus || "—";

    const fechaTop =
      tipo === "Solicitud"
        ? solicitud.fecha_factura
          ? String(solicitud.fecha_factura).slice(0, 10)
          : "—"
        : pago.fecha || "—";

    return (
      <div className="vd-summaryBar">
        <div className="vd-summaryMain">
          <div className="vd-summaryTitle">Ticket #{ticket}</div>
        </div>

        <div className="vd-summaryStats">
          <div className="vd-stat">
            <span className="vd-statLabel">Estatus</span>
            <span
              className={`vd-statValue ${isFacturada ? "vd-statusFacturado" : ""
                }`}
            >
              {estatusTop}
            </span>
          </div>

          <div className="vd-stat vd-statEditable">
            <span className="vd-statLabel">Fecha factura</span>

            {tipo === "Solicitud" ? (
              <input
                className="vd-statInput"
                type="date"
                value={String(solicitud.fecha_factura || "").slice(0, 10)}
                disabled={isFacturada}
                readOnly={isFacturada}
                onChange={(e) =>
                  this.onSolicitudChange("fecha_factura", e.target.value)
                }
              />
            ) : (
              <span className="vd-statValue">{fechaTop}</span>
            )}
          </div>
        </div>
      </div>
    );
  };

  renderPagoView = () => {
    const { data } = this.props;
    const pago = data?.pago || {};
    const tienePagosRelacionados = (data?.pagosrelacionados || []).length > 0;
    const tieneProductos = (data?.productos || []).length > 0;

    return (
      <>
        <div className="vd-card">
          <div className="vd-cardHead">
            <div>
              <div className="vd-cardTitle">Información del pago</div>
              <div className="vd-cardDesc">
                Esta sección es únicamente informativa.
              </div>
            </div>
          </div>

          <div className="vd-grid">
            {this.renderReadField("Locación", pago.locacion)}
            {this.renderReadField("Método de pago", pago.metodo_pago)}
            {this.renderReadField("Detalles", pago.detalles, "vd-span-2")}

            {this.renderReadField("T. C.", this.getTipoCambioValue(pago))}
            {this.renderReadField("Moneda Cobro", pago.moneda_cobro)}


            {this.renderReadField("Total", this.formatMoney(pago.total))}
            {this.renderReadField("Propina", this.formatMoney(pago.propina))}
            {this.renderReadField("Cobrado", this.formatMoney(pago.total_cobrado))}

            {this.renderReadField("IVA MXN", this.formatMoney(pago.ivamxn))}
            {this.renderReadField("Subtotal MXN", this.formatMoney(pago.subtotalmxn))}
            {this.renderReadField("Total MXN", this.formatMoney(pago.totalmxn))}




            {this.renderReadField("Afiliación", pago.afiliacion)}
            {this.renderReadField("Moneda", pago.moneda)}
            {this.renderReadField("Banco", pago.banco)}
            {this.renderReadField("Compañía", pago.compania)}
            {this.renderReadField("Cuenta", pago.cuenta)}
            {this.renderReadField("Estatus del pago", pago.estatus)}

            {this.renderReadField("Ajuste", pago.ajustes)}


          </div>
        </div>

        {tienePagosRelacionados && (
          <div className="vd-card">
            <div className="vd-cardHead">
              <div className="vd-cardTitle">Pagos relacionados</div>
            </div>

            <div className="vd-tableWrap">
              <table className="vd-table">
                <thead>
                  <tr>
                    <th>Método</th>
                    <th>Total</th>
                    <th>Propina</th>
                    <th>T. C.</th>
                    <th>Cobrado</th>
                    <th>Moneda Cobro</th>
                    <th>Hora</th>
                    <th>Estatus</th>
                  </tr>
                </thead>
                <tbody>

                  {(data?.pagosrelacionados || []).map((p) => (
                    <tr key={p.idticketpago}>
                      <td>{p.metodo_pago || "—"}</td>
                      <td>{this.pesostable(p.total || 0)}</td>
                      <td>{this.pesostable(p.propina || 0)}</td>
                      <td>{this.getTipoCambioValue(p)}</td>


                      <td style={{ fontWeight: p.diferencia === 1 ? "bold" : "normal", color: p.diferencia === 1 ? "red" : "black" }}>{this.pesostable(p.total_cobrado) || "—"}</td>


                      <td>{p.moneda_cobro || "—"}</td>
                      <td>{p.hora || "—"}</td>
                      <td>{p.estatus || "—"}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {tieneProductos && (
          <div className="vd-card">
            <div className="vd-cardHead">
              <div className="vd-cardTitle">Productos del ticket</div>
            </div>

            <div className="vd-tableWrap">
              <table className="vd-table">
                <thead>
                  <tr>
                    <th>Producto</th>
                    <th>Cantidad</th>
                    <th>SKU</th>
                    <th>IVA 16%</th>
                    <th>Subtotal</th>
                    <th>Total</th>
                  </tr>
                </thead>



                <tbody>
                  {(data?.productos || []).map((p) => (
                    <tr key={p.idticketproducto}>
                      <td>{p.producto || "—"}</td>
                      <td>{p.cantidad || 0}</td>
                      <td>{p.sku || "—"}</td>
                      <td>{this.pesostable(p.iva) || "—"}</td>
                      <td>{this.pesostable(p.subtotal) || "—"}</td>
                      <td>{this.pesostable(p.total || 0)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </>
    );
  };

  renderSolicitudView = () => {
    const { data } = this.props;
    const { solicitud, productos, emisor, cfdi } = this.state;
    const pagos = data?.pagos || [];
    const tienePagos = pagos.length > 0;
    const isFacturada = this.isSolicitudFacturada();

    const formaPagoOptions = this.getCatalogItems("forma_pago").map((x) => ({
      value: x.clave,
      label: `${x.clave} ${x.forma_pago}`,
    }));

    const metodoPagoOptions = this.getCatalogItems("metodo_pago").map((x) => ({
      value: x.clave,
      label: `${x.clave} ${x.metodo_pago}`,
    }));

    const regimenFiscalOptions = this.getCatalogItems("regimen_fiscal").map(
      (x) => ({
        value: x.clave,
        label: `${x.clave} ${x.regimen_fiscal}`,
      })
    );

    const usoCfdiOptions = this.getCatalogItems("uso_cfdi").map((x) => ({
      value: x.clave,
      label: `${x.clave} ${x.uso_cfdi}`,
    }));

    const tipoComprobanteOptions = this.getCatalogItems(
      "tipo_comprobante"
    ).map((x) => ({
      value: x.clave,
      label: `${x.clave} ${x.tipo_comprobante}`,
    }));

    const totalSeleccionado = this.getTotalProductosSeleccionados();
    const validacionOk = this.isProductosTotalValido();

    return (
      <>
        <div className="vd-stackSections">
          <div className="vd-card">
            <div className="vd-cardHead">
              <div>
                <div className="vd-cardTitle">Datos de la solicitud</div>
                <div className="vd-cardDesc">
                  Datos generales de la solicitud.
                </div>
              </div>
            </div>

            <div className="vd-grid vd-gridSolicitud">
              {this.renderReadField("Ticket", solicitud.idticket)}
              {this.renderReadField("Locación", solicitud.locacion)}
              {this.renderEmptyField()}

              {this.renderEditField("Nombre", "nombre", solicitud.nombre)}
              {this.renderEditField("Apellido", "apellido", solicitud.apellido)}
              {this.renderEditField("RFC", "rfc", solicitud.rfc)}

              {this.renderSelectField({
                label: "Régimen Fiscal *",
                value: solicitud.regimen_fiscal,
                onChange: (value) =>
                  this.onSolicitudChange("regimen_fiscal", value),
                options: regimenFiscalOptions,
              })}

              {this.renderEditField(
                "Domicilio Fiscal",
                "domicilio_fiscal",
                solicitud.domicilio_fiscal
              )}

              <div className="vd-field">
                <label>Nacionalidad</label>
                <select
                  value={String(solicitud.idnacionalidad || "")}
                  disabled={isFacturada}
                  onChange={(e) => this.onNacionalidadSelect(e.target.value)}
                >
                  <option value="">Selecciona una nacionalidad</option>
                  {(Array.isArray(this.props.array_nacionalidad)
                    ? this.props.array_nacionalidad
                    : []
                  ).map((n) => (
                    <option
                      key={n.idnacionalidad}
                      value={String(n.idnacionalidad)}
                    >
                      {n.nacionalidad} {n.codigo ? `(${n.codigo})` : ""}
                    </option>
                  ))}
                </select>
              </div>

              <div className="vd-field">
                <label>Residencia Fiscal</label>
                <input
                  type="text"
                  style={{ backgroundColor: "#f8fafc", cursor: "not-allowed" }}
                  value={solicitud.residencia_fiscal || ""}
                  disabled
                  readOnly
                  title="Selecciona una nacionalidad. La Residencia Fiscal se llena automáticamente."
                />
              </div>

              {this.renderReadField("Tipo ID", solicitud.tipo_id || "Pasaporte")}

              {this.renderEditField(
                "Pasaporte",
                "pasaporte",
                solicitud.pasaporte
              )}

              {this.renderEditField(
                "Fecha tránsito",
                "fecha_transito",
                solicitud.fecha_transito,
                "date"
              )}

              {this.renderSelectField({
                label: "Tipo Tránsito",
                value: solicitud.tipo_transito,
                onChange: (value) =>
                  this.onSolicitudChange("tipo_transito", value),
                options: [
                  { value: "Entrada", label: "Entrada" },
                  { value: "Salida", label: "Salida" },
                ],
              })}

              {this.renderSelectField({
                label: "Vía",
                value: solicitud.via,
                onChange: (value) => this.onSolicitudChange("via", value),
                options: [
                  { value: "Aérea", label: "Aérea" },
                  { value: "Marítima", label: "Marítima" },
                  { value: "Terrestre", label: "Terrestre" },
                ],
              })}

              {this.renderEditField(
                "Línea de Transporte",
                "linea_transporte",
                solicitud.linea_transporte
              )}

              {this.renderEditField(
                "ID Transporte",
                "id_transporte",
                solicitud.id_transporte
              )}

              {this.renderEmptyField()}

              {this.renderEditField("Carpeta", "carpeta", solicitud.carpeta)}

              {this.renderTextAreaField(
                "Comentarios",
                "comentarios",
                solicitud.comentarios,
                "vd-span-2"
              )}
            </div>
          </div>

          <div className="vd-card">
            <div className="vd-cardHead">
              <div>
                <div className="vd-cardTitle">Emisor</div>
                <div className="vd-cardDesc">Información no editable.</div>
              </div>
            </div>

            <div className="vd-grid vd-gridTwoCols">
              {this.renderReadField("Nombre", emisor.nombre)}
              {this.renderReadField("RFC", emisor.rfc)}

              <div className="vd-field">
                <label>Lugar Expedición</label>
                <input
                  type="text"
                  value={emisor.lugar_expedicion || ""}
                  disabled={isFacturada}
                  readOnly={isFacturada}
                  onChange={(e) =>
                    this.onEmisorChange("lugar_expedicion", e.target.value)
                  }
                />
              </div>

              {this.renderReadField(
                "Régimen Fiscal",
                `${emisor.regimen_fiscal || ""} ${this.getCatalogLabel("regimen_fiscal", emisor.regimen_fiscal) ||
                  ""
                  }`.trim()
              )}
            </div>
          </div>

          <div className="vd-card">
            <div className="vd-cardHead">
              <div>
                <div className="vd-cardTitle">CFDI 4.0</div>
                <div className="vd-cardDesc">Datos fiscales de la factura.</div>
              </div>
            </div>

            <div className="vd-grid vd-gridSolicitud">
              {this.renderCfdiField("Serie", "serie", cfdi.serie)}
              {this.renderCfdiField("Folio", "folio", cfdi.folio)}
              {this.renderReadField("Tipo Cambio", cfdi.tipocambiofactura)}

              {this.renderSelectField({
                label: "Forma Pago *",
                value: cfdi.forma_pago,
                onChange: (value) => this.onCfdiChange("forma_pago", value),
                options: formaPagoOptions,
              })}

              {this.renderSelectField({
                label: "Método Pago *",
                value: cfdi.metodo_pago,
                onChange: (value) => this.onCfdiChange("metodo_pago", value),
                options: metodoPagoOptions,
              })}

              {this.renderSelectField({
                label: "Tipo Comprobante *",
                value: cfdi.tipo_comprobante,
                onChange: (value) =>
                  this.onCfdiChange("tipo_comprobante", value),
                options: tipoComprobanteOptions,
              })}

              {this.renderSelectField({
                label: "Uso CFDI *",
                value: cfdi.uso_cfdi,
                onChange: (value) => this.onCfdiChange("uso_cfdi", value),
                options: usoCfdiOptions,
              })}

              <div className="vd-field">
                <label>Moneda *</label>
                <select
                  value={cfdi.moneda || "MXN"}
                  disabled={isFacturada}
                  onChange={(e) => this.onCfdiChange("moneda", e.target.value)}
                >
                  <option value="MXN">MXN</option>
                  <option value="USD">USD</option>
                </select>
              </div>

              <div className="vd-field">
                <label>Cantidad *</label>

                <div className="vd-inputMoney">
                  <span className="vd-prefix">$</span>

                  <input
                    style={{ paddingLeft: "20px" }}
                    type="text"
                    inputMode="decimal"
                    value={solicitud.cantidad || ""}
                    disabled={isFacturada}
                    readOnly={isFacturada}
                    onChange={(e) => {
                      const value = e.target.value
                        .replace(",", ".")
                        .replace(/[^0-9.]/g, "");

                      const parts = value.split(".");
                      const normalized =
                        parts.length > 2
                          ? `${parts[0]}.${parts.slice(1).join("")}`
                          : value;

                      this.onSolicitudChange("cantidad", normalized);
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        {tienePagos && (
          <div className="vd-card">
            <div className="vd-cardHead">
              <div className="vd-cardTitle">Pagos</div>
            </div>

            <div className="vd-tableWrap">
              <table className="vd-table">
                <thead>
                  <tr>
                    <th>Ticket</th>
                    <th>Método de Pago</th>
                    <th>Total</th>
                    <th>Propina</th>
                    <th>T. C.</th>
                    <th>Cobrado</th>
                    <th>Moneda Cobro</th>
                    <th>Estatus</th>
                    <th>Afiliación</th>
                    <th>Moneda</th>
                    <th>Banco</th>
                    <th>Total MXN</th>
                  </tr>
                </thead>
                <tbody>

                  {pagos.map((p) => (
                    <tr key={p.idticketpago}>
                      <td>{p.idticket || "—"}</td>

                      <td>{p.metodo_pago || "—"}</td>
                      <td>{this.pesostable(p.total) || "—"}</td>
                      <td>{p.propina || "—"}</td>
                      <td>{this.getTipoCambioValue(p)}</td>

                      <td style={{ fontWeight: p.diferencia === 1 ? "bold" : "normal", color: p.diferencia === 1 ? "red" : "black" }}>{this.pesostable(p.total_cobrado) || "—"}</td>


                      <td>{p.moneda_cobro || "—"}</td>
                      <td>{p.estatus || "—"}</td>
                      <td>{p.afiliacion || "—"}</td>
                      <td>{p.moneda || "—"}</td>
                      <td>{p.banco || "—"}</td>
                      <td>{this.pesostable(p.totalmxn) || "—"}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div className="vd-ajustesRow">
              <div className="vd-ajustesMsg">
                {solicitud.mensajeajustes}
              </div>

              <div className="vd-totalesVentasRight">
                <div className="vd-totalRow">
                  <span>Total Ventas</span>
                  <span>{this.formatMoney(solicitud.totalventas)}</span>
                </div>

                <div className="vd-totalRow">
                  <span>Total Ventas MXN</span>
                  <span>{this.formatMoney(solicitud.totalventasMXN)}</span>
                </div>
              </div>
            </div>
          </div>
        )}

        <div className="vd-card">
          <div className="vd-cardHead vd-cardHeadProducts">
            <div>
              <div className="vd-cardTitle">Productos</div>
              <div className="vd-cardDesc">
                Si el producto está activo, su total mínimo será de 0.01 por
                cada unidad de cantidad. Si se desactiva, total, IVA y subtotal
                quedan en 0.00.
              </div>
            </div>

            <div className={`vd-counter ${validacionOk ? "ok" : "error"}`}>
              Suma: {totalSeleccionado.toFixed(2)}
            </div>
          </div>

          <div className="vd-tableWrap">
            <table className="vd-table">
              <thead>
                <tr>
                  <th>Producto</th>
                  <th>Cantidad</th>
                  <th>SKU</th>
                  <th>Clave SAT</th>
                  <th>IVA 16%</th>
                  <th>Subtotal</th>
                  <th>Total</th>
                  <th>Activo</th>
                </tr>
              </thead>
              <tbody>
                {productos.length === 0 ? (
                  <tr>
                    <td colSpan="9" className="vd-empty">
                      No hay productos disponibles
                    </td>
                  </tr>
                ) : (
                  productos.map((p) => {
                    const montos = this.getProductoMontos(p);

                    return (
                      <tr key={p.idticketproducto}>
                        <td>{p.producto || "—"}</td>
                        <td>{p.cantidad || 0}</td>
                        <td>{p.sku || "—"}</td>
                        <td>{p.clave_sat || "—"}</td>
                        <td>{this.pesostable(montos.iva)}</td>
                        <td>{this.pesostable(montos.subtotal)}</td>
                        <td>
                          <input
                            ref={(el) =>
                              (this.totalInputs[p.idticketproducto] = el)
                            }
                            className="vd-tableInput"
                            type="text"
                            inputMode="decimal"
                            value={p.total_editable || ""}
                            disabled={!p.seleccionado || isFacturada}
                            readOnly={isFacturada}
                            onChange={(e) => {
                              const value = e.target.value
                                .replace(",", ".")
                                .replace(/[^0-9.]/g, "");

                              const parts = value.split(".");
                              const normalized =
                                parts.length > 2
                                  ? `${parts[0]}.${parts.slice(1).join("")}`
                                  : value;

                              this.onProductoTotalChange(
                                p.idticketproducto,
                                normalized
                              );
                            }}
                            onBlur={() =>
                              this.onProductoTotalBlur(p.idticketproducto)
                            }
                          />
                        </td>
                        <td>
                          <input
                            type="checkbox"
                            checked={!!p.seleccionado}
                            disabled={isFacturada}
                            onChange={() =>
                              this.onToggleProducto(p.idticketproducto)
                            }
                          />
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          </div>
        </div>

        <div className="vd-card">
          <div className="vd-grid vd-gridFacturacionFinal">


            {this.renderReadField("T. C. Factura", solicitud.tipocambiofactura || cfdi.tipocambiofactura)}

            {this.renderReadField("Moneda Factura", solicitud.monedafactura || cfdi.moneda)}

            {this.renderReadField("IVA Factura", this.formatMoney(solicitud.ivafactura))}
            {this.renderReadField("Total Factura", this.formatMoney(solicitud.totalfactura))}


          </div>
        </div>


      </>
    );
  };

  renderMensjeAjustes = () => {
    const { item } = this.state;
    const serverMessage = String(item?.mensajeajustes || "").trim();

    return (
      <div className="vd-footLeft">
        {serverMessage ? (
          <div className="vd-footError">{serverMessage}</div>
        ) : null}
      </div>
    );
  };

  renderFooterLeft = () => {
    const { solicitud } = this.state;
    const serverMessage = String(solicitud?.mensaje || "").trim();

    return (
      <div className="vd-footLeft">
        {serverMessage ? (
          <div className="vd-footError">{serverMessage}</div>
        ) : null}
      </div>
    );
  };

  renderCancelarConfirm = () => {
    if (!this.state.showCancelarConfirm) return null;

    const folio = String(
      this.state?.solicitud?.folio || this.state?.cfdi?.folio || ""
    ).trim();

    return (
      <div className="vd-confirmBackdrop">
        <div className="vd-confirmModal">
          <div className="vd-confirmTitle">Cancelar factura</div>

          <div className="vd-confirmBody">
            La factura con <b>Ticket #{folio || "—"}</b> se cancelará.
            <br />
            ¿Desea continuar?
          </div>

          <div className="vd-confirmActions">
            <button
              type="button"
              className="vd-btn vd-btnGhost"
              onClick={this.closeCancelarConfirm}
            >
              Cancelar
            </button>

            <button
              type="button"
              className="vd-btn vd-btnPrimary"
              onClick={this.confirmarCancelarFactura}
            >
              Continuar
            </button>
          </div>
        </div>
      </div>
    );
  };

  render() {
    const { show, loading, onClose, data } = this.props;

    if (!show) return null;

    const tipo = data?.tipo || "";
    const action = this.getPrimaryActionConfig();

    return (
      <div className="vd-backdrop">
        <div className="vd-modal vd-modalWide">
          <div className="vd-head">
            <div className="vd-headText">
              <div className="vd-title">
                {tipo === "Solicitud"
                  ? "Detalle de solicitud"
                  : "Detalle de pago"}
              </div>
            </div>

            <button type="button" className="vd-close" onClick={onClose}>
              ×
            </button>
          </div>

          {loading ? (
            <div className="vd-loading">Cargando detalles...</div>
          ) : (
            <>
              {this.renderResumen()}

              <div className="vd-body vd-bodyNoHorizontal">
                {tipo === "Solicitud"
                  ? this.renderSolicitudView()
                  : this.renderPagoView()}
              </div>

              <div className="vd-foot vd-footSplit">
                {this.renderFooterLeft()}

                <div className="vd-footRight">
                  <button
                    type="button"
                    className="vd-btn vd-btnGhost"
                    onClick={onClose}
                  >
                    Cerrar
                  </button>

                  {tipo === "Solicitud" && !this.isSolicitudFacturada() && (
                    <button
                      type="button"
                      className="vd-btn vd-btnPrimary"
                      onClick={action.onClick}
                      disabled={action.disabled}
                    >
                      {action.label}
                    </button>
                  )}
                </div>
              </div>
            </>
          )}

          {this.renderCancelarConfirm()}
        </div>
      </div>
    );
  }
}